import { ScreenContent, ScreenContentProps } from "@shared/application-components"
import { PropsWithChildren } from "react"
import { useUI } from "../contexts"

type Props = Omit<ScreenContentProps, "statusBar">

export const ScreenContentWithContext = ({ ...props }: PropsWithChildren<Props>) => {
  const { statusBar } = useUI()
  return <ScreenContent {...{ statusBar, ...props }} />
}
